import * as config from 'config';
import { apiFetch, getAuthorizationHeaders } from 'utils/fetch';
import {
  CreateRolloutRequest,
  DeviceFilter,
  DevicesInRolloutResponse,
  GroupssInRolloutResponse,
  Rollout,
  RolloutFilter,
  RolloutResponse,
  RolloutsResponse,
} from 'models/rollout';

export async function findRollouts(
  offset: number,
  limit: number,
  filter: RolloutFilter[]
): Promise<RolloutsResponse> {
  let filterString = '';
  filter.forEach(
    (f) =>
      (filterString = filterString.concat(`&filter[${f.attribute}]=${f.value}`))
  );
  const url = `${config.backendApi}/rollouts?offset=${offset}&limit=${limit}${filterString}`;
  const headers = getAuthorizationHeaders();
  return apiFetch(url, { headers });
}

export async function getRolloutById(
  rolloutId: string
): Promise<RolloutResponse> {
  const url = `${config.backendApi}/rollouts/${rolloutId}`;
  const headers = getAuthorizationHeaders();
  return apiFetch(url, { headers });
}

export async function createRollout(
  createRolloutRequest: CreateRolloutRequest
): Promise<Rollout> {
  const url = `${config.backendApi}/rollouts`;
  const headers = getAuthorizationHeaders();
  const options = {
    method: 'POST',
    body: JSON.stringify(createRolloutRequest),
    headers,
  };
  return apiFetch(url, options);
}

export async function startRolloutById(
  rolloutId: string
): Promise<RolloutResponse> {
  const url = `${config.backendApi}/rollouts/${rolloutId}/start`;
  const headers = getAuthorizationHeaders();
  const options = {
    method: 'POST',
    headers,
  };
  return apiFetch(url, options);
}

export async function cancelRolloutById(
  rolloutId: string,
  offset: number
): Promise<RolloutResponse> {
  const url = `${config.backendApi}/rollouts/${rolloutId}/cancel?limit=300&offset=${offset}`;
  const headers = getAuthorizationHeaders();
  const options = {
    method: 'POST',
    headers,
  };
  return apiFetch(url, options);
}

export async function getGroupsInRolloutByRolloutId(
  rolloutId: string,
  offset: number,
  limit: number
): Promise<GroupssInRolloutResponse> {
  const url = `${config.backendApi}/rollouts/${rolloutId}/groups?limit=${limit}&offset=${offset}`;
  const headers = getAuthorizationHeaders();
  return apiFetch(url, { headers });
}

export async function getDevicesInRolloutByFilter(
  rolloutId: string,
  filter: DeviceFilter[],
  offset: number,
  limit: number
): Promise<DevicesInRolloutResponse> {
  let filterString = '';
  filter.forEach(
    (f) =>
      (filterString = filterString.concat(`&filter[${f.attribute}]=${f.value}`))
  );

  const url = `${config.backendApi}/rollouts/${rolloutId}/devices?limit=${limit}&offset=${offset}${filterString}`;
  const headers = getAuthorizationHeaders();
  return apiFetch(url, { headers });
}
